<script lang="ts">
  import { onMount, getContext } from "svelte";
  import Icon from "../../../../common/icons/Icon.svelte";
  import Button from "../../../../common/form/Button.svelte";
  import Switch from "../../../../common/form/Switch.svelte";
  import Counter from "../../../common/Counter.svelte";
  import Plan from "./Plan.svelte";
  import { plansDescription } from "../../../../../app/store/store-plan";
  import type { CreateNewAccountContext } from "../../type";
  import { CREATE_NEW_ACCOUNT_CONTEXT_NAME } from "../../utils";
  import {
    plansDataStore,
    getPlanPerSeatCost,
  } from "../../../../../app/store/store-plan";
  import { createForm } from "felte";
  // import * as yup from "yup";
  // import { validator } from "@felte/validator-yup";

  const context: CreateNewAccountContext = getContext(
    CREATE_NEW_ACCOUNT_CONTEXT_NAME
  );
  let planTier = context.getPlanTier();
  let accountType = context.getAccountType();
  let numberOfLicenses = context.getNumberOfLicenses();
  let duration = context.getPlanDuration();
  let isYearly: boolean = duration === "yearly";
  function handleBackButtonClick() {
    context.onPrevious();
  }

  const { form, setData } = createForm({
    onSubmit: (values) => {
      context.onNext(values);
    },
  });

  onMount(() => {
    setData("numberOfLicenses", numberOfLicenses);
    setData("duration", duration);
  });

  $: plansData = $plansDataStore;
  $: activePlan = plansDescription.find((p) => p.value === planTier);
  $: numberOfLicenses, setData("numberOfLicenses", numberOfLicenses);
  $: duration = isYearly ? "yearly" : "monthly";
  $: duration, setData("duration", duration);
</script>

<form use:form method="POST" class:opacity-0={!plansData}>
  <div class="mt-6">
    <div>
      <button
        class="back-button"
        type="button"
        on:click={handleBackButtonClick}
      >
        <Icon icon="splide-arrow-left" width="11px" height="7px" fill="none" />
      </button>
    </div>

    <div class="select-plan-title">
      <span class="text-dark-100 font-semibold uppercase tracking-[0.05em]">
        Select your plan
      </span>

      <div class="flex flex-row items-center">
        <div class="relative mr-2 text-dark-300 font-medium">
          <div class="opacity-0">Monthly</div>
          <div
            class="absolute left-0 right-0 top-0 bottom-0 {!isYearly
              ? 'text-dark-300 font-medium'
              : 'text-dark-50 font-normal'}"
          >
            Monthly
          </div>
        </div>

        <Switch bind:on={isYearly} />

        <div class="relative ml-2 mr-1 text-dark-300 font-medium">
          <div class="opacity-0">Yearly</div>
          <div
            class="absolute left-0 right-0 top-0 bottom-0 {isYearly
              ? 'text-dark-300 font-medium'
              : 'text-dark-50 font-normal'}"
          >
            Yearly
          </div>
        </div>

        <span
          class="px-2.5 py-[3px] rounded-[20px] text-[9px] font-medium uppercase text-tertiary-orange bg-tertiary-orange bg-opacity-[0.08]"
        >
          Save 20%
        </span>
      </div>
    </div>

    <div class="select-plan-container" role="radiogroup">
      {#each plansDescription as plan}
        {@const selected = activePlan.value === plan.value}

        <label>
          <input
            type="radio"
            class="absolute w-0 h-0 opacity-0"
            bind:group={planTier}
            name="plan"
            value={plan.value}
          />
          <Plan data={plan} {selected} {duration} />
        </label>
      {/each}
    </div>
  </div>

  <div class="mt-6 mb-5" class:hidden={accountType === "individual"}>
    <div class="mb-1.5">
      <span class="text-dark-200">Number of Licenses </span>
      <span class="font-medium text-primary-indigo-blue italic">
        ($ {getPlanPerSeatCost(planTier, isYearly ? "yearly" : "monthly")} per user)
      </span>
    </div>

    <Counter bind:count={numberOfLicenses} />
  </div>

  <div class="mb-3 text-dark-50" class:mt-24={accountType === "individual"}>
    *We use <span class="text-dark-200 font-medium italic">Google Cloud</span>.
    If you need a custom region or certain security credentials Contact Us.
  </div>

  <div class="submit-button relative mt-3">
    <Button class="w-full">Continue</Button>
  </div>
</form>

<style lang="postcss">
  .select-plan-title {
    @apply mt-3 flex flex-row items-center justify-between;
  }

  @media (max-width: 500px) {
    .select-plan-title {
      @apply flex flex-col items-start gap-2;
    }
  }

  .select-plan-container {
    @apply flex flex-row items-start justify-between gap-5 mt-3;
  }

  @media (max-width: 700px) {
    .select-plan-container {
      @apply flex flex-col items-start gap-2;
    }
  }

  .back-button {
    @apply flex flex-row items-center justify-center w-7 h-7 rounded-full text-center border-0 text-dark-50 bg-light-50 bg-opacity-70;
    --duration: 0.3s;
    transition: color var(--duration) ease-in-out,
      background var(--duration) ease-in-out,
      opacity var(--duration) ease-in-out,
      box-shadow var(--duration) ease-in-out;
  }

  .back-button:hover,
  .back-button:active {
    @apply bg-light-50 bg-opacity-100 text-dark-300;
    box-shadow: 0px 3px 10px rgba(55, 84, 170, 0.16);
  }
</style>
